import { FeatureFlag, useFeatureFlag } from "./useFeatureFlag";

/**
 * @returns true if Jigsaw metric data should be used instead of the old data
 **/
export const useJigsawMetrics = (): boolean => {
  const { isEnabled } = useFeatureFlag(FeatureFlag.JIGSAW_METRICS);
  return Boolean(isEnabled);
};
